export enum SiteActivityType {
    SITE = 'site',
    HOME_TRANSCRIPTION = 'home', // URL used when a home activity is transcribed by a site user
    HOME_VIEW = 'home_view', // The DCR functionality not restricted to DCR user is only available here for home activities
    DCR = 'dcr', // Home Activity DCR URL accessed by Data Changes Support User when DCRing a home activity
}
